import React from 'react'
import { useParams } from 'react-router-dom'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import EdiContactsCard from 'apps/marketplace/pages/shippers/components/ShipperEdi/components/EdiContactsCard/EdiContactsCard'

const useShipperContactsStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  titleText: {
    display: 'flex',
    flex: theme.spacing(1),
    alignItems: 'center',
  },
}))

export const ShipperConfigContacts = () => {
  const classes = useShipperContactsStyles()

  const { id: shipperId } = useParams<{ id: string }>()

  return (
    <div className={classes.root}>
      <Box display='flex' justifyContent='center' alignItems='center' pl={2} pr={2}>
        <Typography variant='h2' className={classes.titleText}>
          <span className='mr3' data-test='inbound-connection-config-identifier-header'>
            {`Shipper - ${shipperId}`}
          </span>
        </Typography>
      </Box>
      <EdiContactsCard shipperId={shipperId} />
    </div>
  )
}
